import { Features } from '@common/common.constant';


export const NavMenuItems = [
    {
      displayName: 'Reports',
      path: 'reports',
      activeTab: 'reports',
      icon: 'insert_chart_outlined',
      disabled : false,
      roles: ['admin', 'superadmin', 'user'],
      name: Features.reports
    },
    {
      displayName: 'User Management',
      path: 'user-management',
      activeTab: 'user-management',
      icon: 'person_outline',
      disabled : false,
      roles: ['admin', 'superadmin'],
      name: Features.userManagement
    },
    {
      displayName: 'Device Management',
      path: 'device-management',
      activeTab: 'device-management',
      icon: 'phone_iphone',
      disabled : true,
      roles: ['admin', 'superadmin', 'user'],
      name: Features.deviceManagement
    },
    {
      displayName: 'IFA List',
      path: 'ifa-list',
      activeTab: 'ifa-list',
      icon: 'list_alt',
      disabled : false,
      roles: ['admin', 'superadmin', 'user'],
      name: Features.ifaList
    },
    {
      displayName: 'Investor List',
      path: 'investor-list',
      activeTab: 'investor-list',
      icon: 'people_outline',
      disabled : false,
      roles: ['admin', 'superadmin', 'user'],
      name: Features.investors
    },
    {
      displayName: 'Push Notifications',
      path: 'push-notifications',
      activeTab: 'push-notifications',
      icon: 'notifications_none',
      disabled : false,
      roles: ['admin', 'superadmin', 'user'],
      name: Features.pushNotification
    },
    {
      displayName: 'Update Content',
      path: 'catalogue',
      activeTab: 'catalogue',
      icon: 'work_outline',
      disabled : false,
      roles: ['admin', 'superadmin', 'user'],
      name:  Features.updateContent
    },
  ];